import { useSegment as useSegmentBase } from "@bigspring/core-components/helpers";

export function useSegment() {
  return useSegmentBase(process.env.NEXT_PUBLIC_SEGMENT_ENABLED === "1");
}
